import {
  TaskCategory,
  TaskCategoryWorkflowType,
  TaskStepDto,
} from '@urbanx/agx.activities.client'
import { AgxBadge, AgxCheckbox, AgxTypography } from '@urbanx/agx.ui-components2'
import clsx from 'clsx'
import { getTaskStepDueDate } from 'utils/tasks'
import TaskDueDateBadge from './TaskDueDateBadge'
import { useMemo } from 'react'

interface TaskStepItemProps {
  step: TaskStepDto
  allStepsCompleted: boolean
  campaignId?: string
  contractId?: string
  category?: TaskCategory
  toggleTaskSteps: (payload: {
    stepIds: number[]
    workflowType: TaskCategoryWorkflowType
    category?: TaskCategory
    campaignId?: string
    contractId?: string
  }) => void
}

const TaskStepItem = ({
  step,
  allStepsCompleted,
  campaignId,
  contractId,
  category,
  toggleTaskSteps,
}: TaskStepItemProps) => {
  const labelText = step.name ?? ''
  const helperText = step.data?.text
  const badgeMessage = step.data?.badgeMessage?.trim()
  const stepDueDate = useMemo(() => getTaskStepDueDate(step), [step])
  const hasHelperContent =
    Boolean(helperText) || Boolean(badgeMessage) || Boolean(stepDueDate)

  return (
    <div
      className={clsx('taskStep-container', 'taskStep-item', {
        disabled: allStepsCompleted,
      })}
    >
      <AgxCheckbox
        id={`${step.order}-${step.name}`}
        checked={!!step.isCompleted}
        onChange={() =>
          toggleTaskSteps({
            stepIds: [step.order!],
            workflowType: category?.workflowType as TaskCategoryWorkflowType,
            category,
            campaignId,
            contractId,
          })
        }
        strikethroughOnCheck
        label={labelText}
        disabled={allStepsCompleted}
      />
      {hasHelperContent && (
        <div className="taskStep-helperContent">
          <AgxTypography
            id={`task-step-helper-${step.order}`}
            key={`task-step-helper-${step.order}`}
            type={'body_ui_strong'}
            size={'medium'}
            color="var(--text-primary)"
          >
            {helperText}
          </AgxTypography>
          {stepDueDate && (
            <div className="taskStep-dueDateBadge">
              <TaskDueDateBadge
                dueDate={stepDueDate}
                isCompleted={step.isCompleted ?? false}
                completedDate={step.completedDate}
              />
            </div>
          )}
          {badgeMessage && (
            <div className="taskStep-helperBadge">
              <AgxBadge
                type="colourfill"
                colour="yellow"
                size="md"
                text={badgeMessage}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default TaskStepItem
